import { httpPost } from "@/request/http";

let path = "/reports/receivable";

export default {
  getPages(params) {
    return httpPost(path, params);
  },
};
